import { ConfigurationAccessGroupsData } from "../api/models/access-groups";
import { PHOTOS } from "./photos";

const WEEK_DAY_ORDER = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
] as const;

const WEEKDAYS = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
] as const;

const WEEKEND = ["saturday", "sunday"] as const;

export const formatAccessScheduleTime = (time?: string | null) => {
  if (!time) return "-";
  return time.slice(0, 5);
};

export const isAllDayAccessSchedule = (
  startTime?: string | null,
  endTime?: string | null,
) => {
  if (!startTime || !endTime) return false;
  return startTime.slice(0, 5) === "00:00" && endTime.slice(0, 5) === "23:59";
};

export const getExitRestrictionFrom = (
  config?: ConfigurationAccessGroupsData | null,
) => config?.exit_restriction_from || config?.exit_restriction || null;

export const getExitRestrictionTo = (
  config?: ConfigurationAccessGroupsData | null,
) => config?.exit_restriction_to || null;

export const hasExitRestrictionSchedule = (
  config?: ConfigurationAccessGroupsData | null,
) => !!(getExitRestrictionFrom(config) || getExitRestrictionTo(config));

const sameDaySet = (days: string[], expected: readonly string[]) => {
  if (days.length !== expected.length) return false;
  return expected.every((day) => days.includes(day));
};

export const formatAllowedDaysLabel = (
  weekDays: string[] = [],
  labels: {
    all_week: string;
    weekdays: string;
    weekend: string;
    monday_2: string;
    tuesday_2: string;
    wednesday_2: string;
    thursday_2: string;
    friday_2: string;
    saturday_2: string;
    sunday_2: string;
  },
) => {
  const orderedDays = WEEK_DAY_ORDER.filter((day) => weekDays.includes(day));

  if (sameDaySet(orderedDays, WEEK_DAY_ORDER)) {
    return labels.all_week;
  }
  if (sameDaySet(orderedDays, WEEKDAYS)) {
    return labels.weekdays;
  }
  if (sameDaySet(orderedDays, WEEKEND)) {
    return labels.weekend;
  }

  return orderedDays
    .map((day) => {
      if (day === "monday") return labels.monday_2;
      if (day === "tuesday") return labels.tuesday_2;
      if (day === "wednesday") return labels.wednesday_2;
      if (day === "thursday") return labels.thursday_2;
      if (day === "friday") return labels.friday_2;
      if (day === "saturday") return labels.saturday_2;
      if (day === "sunday") return labels.sunday_2;
      return day;
    })
    .join(", ");
};

export const formatAccessScheduleLabel = (
  startTime: string | null | undefined,
  endTime: string | null | undefined,
  allDayLabel: string,
) => {
  if (isAllDayAccessSchedule(startTime, endTime)) {
    return allDayLabel;
  }
  return `${formatAccessScheduleTime(startTime)} - ${formatAccessScheduleTime(
    endTime,
  )}`;
};

export const getAccessPhotoLabel = (
  photo: string,
  labels: {
    id: string;
    plates: string;
    portrait: string;
    equipment: string;
  },
) => {
  if (photo === "id") return labels.id;
  if (photo === "plates") return labels.plates;
  if (photo === "visitor") return labels.portrait;
  if (photo === "other") return labels.equipment;
  return photo;
};

export const getAccessPhotoIcon = (photo: string) =>
  PHOTOS.find((item) => item.label === photo)?.icon || "mdi:image";
